import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ linkTo = '/', size = 'default' }) => {
  const sizes = {
    small: { img: 'h-6', label: 'text-base' },
    default: { img: 'h-7', label: 'text-lg' },
    large: { img: 'h-12', label: 'text-xl' }
  };
  const s = sizes[size] || sizes.default;

  return (
    <Link to={linkTo} className="flex items-center gap-2.5 hover:opacity-80 transition-opacity" data-testid="miadesk-logo">
      <img src="/logo-mark.png" alt="Miadesk" className={`${s.img} w-auto`} />
      <span className={`text-white font-medium ${s.label} hidden sm:inline`}>
        Miadesk
      </span>
    </Link>
  );
};

export default Logo;
